import get from "lodash/get";
import React from "react";
import { getStoryElementByType, getStoryElementsByType } from "../../../utils";
import "./overview.m.css";

const Overview = ({ card }) => {
  const eventTitle = get(getStoryElementByType(card, "title"), "text", "");
  const textElements = getStoryElementsByType(card, "text");
  const eventEmbed = get(getStoryElementByType(card, "youtube-video"), "embed-url", "");
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");

  const textContainer = (
     <>
    {textElements.map((element, index) => (
      <div key={index} styleName="div-3">
        <div styleName="text-wrapper" dangerouslySetInnerHTML={{ __html: element.text }} />
      </div>
    ))}
    </>
  );

  return (
    <div className="overview-container" styleName="overview-container" data-model-id="12840:82119" id={`${id.toLowerCase()}`}>
      <div styleName="frame">
        <h1 styleName="event-description" dangerouslySetInnerHTML={{ __html: eventTitle }} />
      </div>

      <div styleName="divider" />

      {eventEmbed && (
        <div styleName="div-2">
          {textContainer}

          <div styleName="group">
            <iframe src={eventEmbed} title="Event Embed" />
          </div>
        </div>
      )}
      {!eventEmbed && textContainer}
    </div>
  );
};

export default Overview;
